import { memo } from 'react';

export type AssetVersionBadgeProps = {
  version: number;
};

export const AssetVersionBadge = memo(({ version }: AssetVersionBadgeProps) => {
  return (
    <div
      className="absolute top-1.5 left-1.5 z-10 flex h-4 items-center justify-center rounded-4 bg-black/60 px-1 font-medium text-10 text-white tracking-wider transition-colors ads:group-data-[state=active]/asset-version:bg-primary group-data-[state=active]/asset-version:bg-blue-9 ads:group-data-[state=active]/asset-version:text-inverse group-data-[state=active]/asset-version:text-gray-12"
      data-testid="ASSET_VERSION_BADGE"
      data-version={version}
    >
      V{version}
    </div>
  );
});

AssetVersionBadge.displayName = 'AssetVersionBadge';
